import { SmartyAddressFields } from '@/src/modules/smarty/SmartyAddressFields'
import { SmartyShippingMethodField } from '@/src/modules/smarty/SmartyShippingMethodField'

interface IDeliveryValues {
    physicalDeliveryOptions: any[]
    lineItemCount: number
}

interface ISmartyProps {
    showShippingOptions: boolean
    deliveryValues?: IDeliveryValues
}

export const SmartyForm = ({
    deliveryValues,
    showShippingOptions = false,
}: ISmartyProps) => {
    if (deliveryValues && showShippingOptions) {
        const { physicalDeliveryOptions, lineItemCount } = deliveryValues

        return (
            <>
                <SmartyAddressFields />
                <SmartyShippingMethodField
                    physicalDeliveryOptions={physicalDeliveryOptions}
                    lineItemCount={lineItemCount}
                />
            </>
        )
    }

    return <SmartyAddressFields />
}
